import script from "./Accordion.vue?vue&type=script&setup=true&lang=ts"
export * from "./Accordion.vue?vue&type=script&setup=true&lang=ts"

import "./Accordion.vue?vue&type=style&index=0&id=4408db75&lang=scss"

const __exports__ = script;

export default __exports__